import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { PlantService } from '../../../../../core/plant-configuration/_services/plant.service';
import { AuthService } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';

@Component({
  selector: 'kt-plant-edit',
  templateUrl: './plant-edit.component.html',
  styleUrls: []
})
export class PlantEditComponent implements OnInit, OnDestroy, AfterViewInit {
  itemObs = new Subject<any[]>();
  editObs = new Subject<number>();
  addObs = new Subject<number>();
  private itemFormOptions = {
    name: ["", Validators.required],
    description: ["", ],
    mqtt_topic: ["", ],
    // company_id: ["-1", Validators.required],
  };
  itemForm = this.formBuilder.group(this.itemFormOptions);
  stepList: any[] = [
    {
      icon: "flaticon2-architecture-and-city", title: "Configuración de planta", subTitle: "Ingrese datos de contacto", form: [
        [
          { name: "name", label: "Nombre", type: "text" },
          { name: "description", label: "Descripción", type: "text" },
        ],
        [
          { name: "mqtt_topic", label: "Tópico mqtt", type: "text" },
        ],
        // [
        //   { name: "company_id", label: "Empresa", type: "list", optionList: []},
        // ]
      ]
    },
  ];

  private subscriptions: Subscription[] = [];
  data: any = {};
  partnerList: any[];
  userList: any[];
  uid: number = -1;
  company: any = null;

  constructor(
    private plantService: PlantService,
    // private companyService: CompanyService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.uid = this.authService.getUID();
    // this.subscriptions.push(
    //     of(null).pipe(
    //         switchMap(()=>this.companyService.companyLoaded$),
    //         filter((companyLoaded)=>companyLoaded==true)
    //     ).subscribe((companyLoaded)=>{
    //       if(companyLoaded){
    //         this.company = this.companyService.getCurrentCompany();
    //       }
    //         // this.stepList[0].form[1][0].optionList = companyList.map(company=>{return{text:company.name, value:company.id}})
    //         // this.data.companyList = companyList;
    //     })
    // )
  }
  ngAfterViewInit() {

  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onItemLoaded(item) {

    console.log("on item load:");
  }

  getItem(itemId: number) {
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.plantService.getById(itemId))
      ).subscribe(item => {
        this.onItemLoaded(item);
        this.itemObs.next(item);
      })
    )
  }

  addItem(item: any) {
    // item.create_uid = this.uid>0?this.uid:'null';
    // item.create_date = "now()";
    // item.is_installation_contact = 'true';
    // item.active = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.plantService.add(item))
      ).subscribe(newId => {
        this.addObs.next(newId);
      })
    )
  }

  editItem(item: any) {
    // item.write_uid = this.uid>0?this.uid:'null';
    // item.write_date = "now()";
    // item.is_installation_contact = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.plantService.edit(item))
      ).subscribe(status => {
        if (status == "success") this.editObs.next(item.id);
        else this.editObs.next(-1);
      })
    )
  }
}